<template>
  <div v-title data-title="玩赚">
    <div class="fxs-bg"></div>
    <div class="fxs-card">
      <img :src="formset.WechatLogoUrl" class="profile" />
      <span>{{formset.WechatName}}</span>
      <p>邀您一起开启赚钱之旅!</p>
      <div class="fxs-zc-form">
        <div class="fxs-input">
          <input type="tel" placeholder="请输入手机号" v-model="user.UserName" />
        </div>
        <div class="fxs-input">
          <input type="text" placeholder="请输入图形码" v-model="PicCodeValue" />
          <img :src="'data:image/png;base64,'+VerificationCodePic.Base64" @click="getpiccode()"/>
        </div>
        <div class="fxs-input">
          <input type="text" placeholder="请输入验证码" v-model="user.Password" />
          <button v-if="getcodeshow&&user.UserName.length==11" @click="getcode(3)">获取验证码</button>
          <button v-if="getcodeshow&&user.UserName.length!=11" @click="getcode(3)">获取验证码</button>
          <button
            class="weui-btn weui-btn_mini btn-orange"
            style="width:inherit;background-color:#ccc"
            v-if="!getcodeshow"
          >{{waitminutes}}秒</button>
        </div>
      </div>
      <a class="fxs-sub" href="javascript:void(0)" @click="checkcode()">一键成为家游客</a>
    </div>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";

export default {
  name: "fun",
  data: function() {
    return {
      formset: {},
      disid: "",
      user: { UserName: "", Password: "" },
      getcodeshow: true,
      waitminutes: "",
      codetimer: null,
      VerificationCodePic: { OnceString: "" }, //图形验证码信息
      PicCodeValue: "" //图形验证码值
    };
  },
  created: function() {
    var url = window.location.href;
    //var disid = this.GetRequest(url)["disid"];
    var disid = this.$route.query.disid;
    if (disid != undefined) {
      this.disid = disid;
    }
    this.initDisInfo();
    //this.regThirdDistributor();
  },
  mounted: function() {
    this.getpiccode();
  },
  methods: {
    initDisInfo: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getuserbyguid", {
          params: {
            guid: this.disid
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    regThirdDistributor: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/regthirddistributor", {
          params: {
            disid: this.disid,
            telephone: this.user.UserName,
            loginType: 4,
            code: this.user.Password
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              if (
                rep.Data.Token != undefined &&
                rep.Data.Token != null &&
                rep.Data.Token.length > 0
              ) {
                localStorage.setItem("token", JSON.stringify(rep.Data.Token));
                Toast.success("注册成功");
                this.$store.commit("hideFun");
                localStorage.setItem("showFun", false);
                this.$router.push({
                  path: "/page/regthirddissuccess",
                  query: {
                    isSubscribe: rep.Data.IsSubscribe
                  }
                });
              }
            } else {
              if (
                rep.Message == "已是家游客，无需注册" ||
                rep.Message == "注册失败，该微信已经绑定家游客"
              ) {
                Dialog.alert({
                  title: "提示信息",
                  message: rep.Message
                }).then(() => {
                  localStorage.removeItem("token");
                  window.location.href = this.GLOBAL.WEB_URL + "/#/app/home";
                });
              } else {
                this.getpiccode();
                Toast.fail(rep.Message);
              }
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    //获取图形验证码
    getpiccode: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcodepic", {
          params: { codeGuid: this.VerificationCodePic.OnceString }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.VerificationCodePic = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    getcode: function() {
      if (
        this.user.UserName == undefined ||
        this.user.UserName == null ||
        this.user.UserName.length == 0
      ) {
        Toast.fail("手机号不能为空");
        return;
      }
      if (
        this.PicCodeValue == undefined ||
        this.PicCodeValue == null ||
        this.PicCodeValue.length == 0
      ) {
        Toast.fail("图形码不能为空");
        return;
      }
      const TIME_COUNT = 60;
      if (!this.codetimer) {
        this.waitminutes = TIME_COUNT;
        this.getcodeshow = false;
        this.codetimer = setInterval(() => {
          if (this.waitminutes > 0 && this.waitminutes <= TIME_COUNT) {
            this.waitminutes--;
          } else {
            this.getcodeshow = true;
            clearInterval(this.codetimer);
            this.codetimer = null;
          }
        }, 1000);
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcode", {
          params: {
            picCode: this.PicCodeValue,
            onceString: this.VerificationCodePic.OnceString,
            telephone: this.user.UserName,
            loginType: 4
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
            } else {
              this.waitminutes = 0;
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    checkcode: function() {
      if (
        this.user.UserName == undefined ||
        this.user.UserName == null ||
        this.user.UserName.length == 0
      ) {
        Toast.fail("手机号不能为空");
        return;
      }
      if (
        this.PicCodeValue == undefined ||
        this.PicCodeValue == null ||
        this.PicCodeValue.length == 0
      ) {
        Toast.fail("图形码不能为空");
        return;
      }
      if (this.user.Password == "") {
        Toast.fail("验证码不能为空");
        return;
      }

      this.regThirdDistributor();
    }
  }
};
</script>





<style>
/* @media screen and (max-height: 700px) {
  .bg {
    padding-top: 85%;
  }

  .fx {
    margin-top: 8%;
    margin-bottom: 48%;
    margin-left: 22%;
  }
}
@media (min-height: 701px) and (max-height: 800px) {
  .bg {
    padding-top: 87%;
  }

  .fx {
    margin: 8% auto;
    margin-bottom: 200px;
  }
}

@media (min-height: 801px) and (max-height: 900px) {
  .bg {
    padding-top: 430px;
  }

  .fx {
    margin: 40px auto;
    margin-bottom: 220px;
  }
}

@media screen and (min-height: 901px) {
  .bg {
    padding-top: 550px;
  }

  .fx {
    margin: 60px auto;
  }
} */

/*-----------fxs-----------*/
.fxs-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url(../../assets/img/fxs-zc.png) no-repeat center top #fdfdfb;
  background-size: 100% 100%;
  z-index: -100;
}

.fxs-card {
  width: 100%;
  margin: 48% auto 0;
  background: url(../../assets/img/fxs-card.png) no-repeat center top;
  background-size: 100% 100%;
  padding: 38% 10px 23% 10px;
  text-align: center;
  box-sizing: border-box;
}

.fxs-card img.profile {
  width: 50px;
  height: 50px;
}

.fxs-card span {
  display: block;
  line-height: 20px;
  font-size: 14px;
}
.fxs-card p {
  width: 55%;
  margin: 10px auto;
  line-height: 30px;
  background: linear-gradient(to right, #f2e5ca, #fcfaf2);
  border-radius: 64px;
}

.fxs-sub {
  display: block;
  width: 60%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(to bottom, #fdb631, #fe7a0d);
  border-radius: 64px;
  margin: 10px auto;
}

.fxs-zc-form {
  width: 60%;
  margin: 10px auto;
}

.fxs-zc-form .fxs-input {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d8d9d9;
  padding-bottom: 5px;
  position: relative;
}

.fxs-zc-form .fxs-input input {
  border: none;
  background: inherit;
  text-align: left;
  padding-left: 10px;
  width: 100%;
}

.fxs-zc-form .fxs-input img {
  position: absolute;
  right: 0;
  top: 5px;
  bottom: 5px;
  width: 80px;
  height: 30px;
}

.fxs-zc-form .fxs-input button {
  position: absolute;
  right: 0;
  top: 5px;
  bottom: 5px;
  width: 80px;
  height: 30px;
  background: linear-gradient(to top, #fdb631, #fe7a0d);
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 64px;
}
</style>




// WEBPACK FOOTER //
// src/components/fun/fun.vue